// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file ProcedureDTO.proto (package ProcedureDTO, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { ProcedureLeg } from "./ProcedureLeg_pb";
import { file_ProcedureLeg } from "./ProcedureLeg_pb";
import type { ProcedureCoordPoints } from "./ProcedureCoordPoints_pb";
import { file_ProcedureCoordPoints } from "./ProcedureCoordPoints_pb";
import type { Navaid } from "./Navaid_pb";
import { file_Navaid } from "./Navaid_pb";
import type { CoordPoint } from "./CoordPoint_pb";
import { file_CoordPoint } from "./CoordPoint_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ProcedureDTO.proto.
 */
export const file_ProcedureDTO: GenFile = /*@__PURE__*/
  fileDesc("ChJQcm9jZWR1cmVEVE8ucHJvdG8SDFByb2NlZHVyZURUTyKwBgoMUHJvY2VkdXJlRFRPEjMKDWFpcmNyYWZ0c3BlZWQYASABKAsyHC5nb29nbGUucHJvdG9idWYuRG91YmxlVmFsdWUSLQoIY29uZmlnSWQYAiABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIuCghmcmVldGV4dBgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRInCgJpZBgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi0KCW1hcHN0YXR1cxgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5Cb29sVmFsdWUSKgoEbmFtZRgGIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIxCgtwcm9jZWR1cmVpZBgHIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIzCg1wcm9jZWR1cmV0eXBlGAggASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi4KCXByb2plY3RJZBgJIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjcKEnJlZmVyZW5jZUFpcnBvcnRQaxgKIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjkKE3JuYXZwZXJmb3JtYW5jZXR5cGUYCyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSMQoNcHJvY2VkdXJlTGVncxgMIAMoCzIaLlByb2NlZHVyZUxlZy5Qcm9jZWR1cmVMZWcSTQoZcHJvY2VkdXJlQ29vcmRpbmF0ZVBvaW50cxgNIAMoCzIqLlByb2NlZHVyZUNvb3JkUG9pbnRzLlByb2NlZHVyZUNvb3JkUG9pbnRzEjAKEHJlZmVyZW5jZUFpcnBvcnQYDiABKAsyFi5Db29yZFBvaW50LkNvb3JkUG9pbnQSHwoHbmF2YWlkcxgPIAMoCzIOLk5hdmFpZC5OYXZhaWQSJwoPY3JpdGljYWxOYXZhaWRzGBAgAygLMg4uTmF2YWlkLk5hdmFpZEJCCi1jb20uZ212LmRlbWV0ZXIubmF2YWlkcy5tb2RlbC5wcm90by5nZW5lcmF0ZWRCEVByb2NlZHVyZURUT1Byb3RvYgZwcm90bzM", [file_ProcedureLeg, file_ProcedureCoordPoints, file_Navaid, file_CoordPoint, file_google_protobuf_wrappers]);

/**
 * @generated from message ProcedureDTO.ProcedureDTO
 */
export type ProcedureDTO = Message<"ProcedureDTO.ProcedureDTO"> & {
  /**
   * @generated from field: google.protobuf.DoubleValue aircraftspeed = 1;
   */
  aircraftspeed?: number;

  /**
   * @generated from field: google.protobuf.Int32Value configId = 2;
   */
  configId?: number;

  /**
   * @generated from field: google.protobuf.StringValue freetext = 3;
   */
  freetext?: string;

  /**
   * @generated from field: google.protobuf.Int32Value id = 4;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.BoolValue mapstatus = 5;
   */
  mapstatus?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue name = 6;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue procedureid = 7;
   */
  procedureid?: string;

  /**
   * @generated from field: google.protobuf.StringValue proceduretype = 8;
   */
  proceduretype?: string;

  /**
   * @generated from field: google.protobuf.Int32Value projectId = 9;
   */
  projectId?: number;

  /**
   * @generated from field: google.protobuf.Int32Value referenceAirportPk = 10;
   */
  referenceAirportPk?: number;

  /**
   * @generated from field: google.protobuf.StringValue rnavperformancetype = 11;
   */
  rnavperformancetype?: string;

  /**
   * @generated from field: repeated ProcedureLeg.ProcedureLeg procedureLegs = 12;
   */
  procedureLegs: ProcedureLeg[];

  /**
   * @generated from field: repeated ProcedureCoordPoints.ProcedureCoordPoints procedureCoordinatePoints = 13;
   */
  procedureCoordinatePoints: ProcedureCoordPoints[];

  /**
   * @generated from field: CoordPoint.CoordPoint referenceAirport = 14;
   */
  referenceAirport?: CoordPoint;

  /**
   * @generated from field: repeated Navaid.Navaid navaids = 15;
   */
  navaids: Navaid[];

  /**
   * @generated from field: repeated Navaid.Navaid criticalNavaids = 16;
   */
  criticalNavaids: Navaid[];
};

/**
 * Describes the message ProcedureDTO.ProcedureDTO.
 * Use `create(ProcedureDTOSchema)` to create a new message.
 */
export const ProcedureDTOSchema: GenMessage<ProcedureDTO> = /*@__PURE__*/
  messageDesc(file_ProcedureDTO, 0);

